import { createSelector } from 'reselect'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import lessonSelector from 'redux/selectors/lessons/lesson_selector'
import lessonTypes from 'helpers/enums/lessonTypes'

const myLibrarySelector = state => state.myLibrary

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.TEACHER_DASHBOARD_SELF_PACED,
])

const myLibraryStudentPacedMultipleCodesSelector = presentationUid => createSelector(
	[myLibrarySelector, featureFlagsSelector, lessonSelector],
	(myLibrary, featureFlags, getLesson) => {
		const lesson = getLesson(presentationUid)

		return {
			codes: myLibrary.codes,
			actualTimestamp: myLibrary.actualTimestamp,
			canAccessProgress: featureFlags[featureFlagsTypes.TEACHER_DASHBOARD_SELF_PACED] &&
				lesson.data.type !== lessonTypes.VIDEO,
		}
	}
)

export default myLibraryStudentPacedMultipleCodesSelector
